var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414751",
    fillRule: "evenodd",
    d: "M13.963 2.937a1.5 1.5 0 0 0-.096-.311 3.3 3.3 0 0 0-.584-.851q-.377-.407-.688-.573a2 2 0 0 0-.348-.133A1.6 1.6 0 0 0 11.836 1a1.3 1.3 0 0 0-.437.059 1.3 1.3 0 0 0-.429.229q-.16.135-.406.364-.245.231-.422.394l2.765 2.776q.101-.091.221-.208.104-.104.246-.237.138-.134.317-.313.162-.175.235-.37A1.1 1.1 0 0 0 14 3.308q0-.19-.037-.37M2.76 9.453q-.324.335-.413.425a3 3 0 0 0-.318.372 2.5 2.5 0 0 0-.2.38q-.072.134-.191.49-.12.36-.245.781-.12.41-.235.818-.11.395-.14.603-.06.384.074.55.133.164.532.118.192-.028.583-.133.392-.105.828-.247.438-.141.836-.288.4-.148.606-.253.207-.09.4-.237.193-.148.34-.282c.04-.027.16-.147.369-.356q.311-.313.784-.795.472-.48 1.063-1.062l1.183-1.202 3.178-3.197L9.03 3.146 3.576 8.628q-.49.491-.815.825"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.bf3577cd.svg";
export { ForwardRef as ReactComponent };